export default __webpack_public_path__ + "static/media/lock.afc767d1.svg";